export default __webpack_public_path__ + "media/images/icons/icon-sandwich-close-b7ce401fb0767c8b7cdb5728f4933146.svg";